import { Col, Row, Avatar, Typography, Modal, message } from "antd";
import React, { useState } from "react";
import { UserOutlined } from "@ant-design/icons";
import profile from "../../../images/profile.svg";
import { StyledButton, StyledLink } from "../../styled-components/components";
import Feedback from "../../Utilities/Feedback";
import { LoadingOutlined } from "@ant-design/icons";
import constants from "../../Redux/constants";
import { connect } from "react-redux";
import { getOfferProgress } from "../../Redux/User/reducer";
import { useHistory } from "react-router";

const UserCard = (props) => {
  const history = useHistory();
  const [openModal, setOpenModal] = useState(false);
  const [loading, setLoading] = useState(false);
  //profileimageUrl,profileimageId
  const applicationId = props.id;
  const offerStatus = props.offerStatus;
  const reason = props.reason;
  const offerId = props.offerId;
  const comment = props.comment;
  const { firstName, lastName, email, mobileNumber, Country, userId } =
    props.user;
  const removeUser = () => {
    props.removeUser(userId);
  };
  const giveOffer = async () => {
    setLoading(true);
    const responseStatus = await props.sendProposal(applicationId);
    if (responseStatus === constants.status.success) {
      setOpenModal(false);
      message.success("Offer has been made", 3);
    }
  };
  const showProgress = async () => {
    history.push(`/job/${props.jobId}/progress/${offerId}`);
  };
  return (
    <Col
      xs={{ span: 22 }}
      sm={{ span: 18 }}
      md={{ span: 16 }}
      lg={{ span: 12 }}
      xl={{ span: 10 }}
      xxl={{ span: 6 }}
      style={{
        margin: "auto",
        marginTop: "2vh",
        marginBottom: "2vh",
        background: "#ffffff",
        borderRadius: "6px",
      }}
    >
      {/* Applicant Info Row */}
      <Row>
        <Col xl={{ span: 6 }} xs={{ span: 6 }} style={{ padding: "3vh" }}>
          <Row>
            <Avatar size="large" src={profile} icon={<UserOutlined />} />
          </Row>
        </Col>
        <Col xs={{ span: 14 }} style={{ padding: "1vh" }}>
          <Row>
            <Col>
              <Row style={{ padding: "0.5vh" }}>
                <Typography.Text strong>
                  {firstName} {lastName}
                </Typography.Text>
              </Row>
              <Row style={{ padding: "0.5vh" }}>
                <Typography.Text>{email}</Typography.Text>
              </Row>
              <Row style={{ padding: "0.5vh" }}>
                <Col xs={{ span: 6 }}>
                  <Row>{Country}</Row>
                </Col>
                <Col>
                  <Row>{mobileNumber}</Row>
                </Col>
              </Row>
            </Col>
          </Row>
        </Col>
        <Row>{comment}</Row>
      </Row>
      {/* Client Action Buttons */}
      {offerId ? (
        <Col>
          {offerStatus === constants.offerStatus.accepted ? (
            <Col>
              <StyledLink data-testid="submit-progress" onClick={showProgress}>
                View Progress
              </StyledLink>
            </Col>
          ) : (
            <Col>
              {offerStatus === constants.offerStatus.reject ? (
                <Col>
                  <Row>
                    <Typography.Text strong>
                      Offer has been Rejected
                    </Typography.Text>
                  </Row>
                  <Row>
                    <Typography.Text>{reason}</Typography.Text>
                  </Row>
                </Col>
              ) : (
                <Col>
                  {offerStatus === constants.offerStatus.expired ? (
                    <Col>
                      <Typography.Text>Offer has been Expired</Typography.Text>
                    </Col>
                  ) : (
                    <Row justify="center">
                      <Typography>Offer Has Been Made Already</Typography>
                    </Row>
                  )}
                </Col>
              )}
            </Col>
          )}
        </Col>
      ) : (
        <Row justify="space-between" style={{ padding: "2vh" }}>
          <Col>
            <StyledButton
              data-testid="submit-cancel"
              color="#d92626"
              onClick={removeUser}
            >
              Cancel
            </StyledButton>
          </Col>
          <Col>
            <StyledButton
              data-testid="submit-accept"
              color="#15EA5F"
              textColor="#222222"
              onClick={() => setOpenModal(true)}
            >
              Accept
            </StyledButton>
          </Col>
        </Row>
      )}

      <Modal
        visible={openModal}
        footer={null}
        width={416}
        onCancel={() => setOpenModal(false)}
      >
        {loading ? (
          <Feedback
            icon={<LoadingOutlined />}
            title={`Sending Proposal to ${firstName} ${lastName}`}
          ></Feedback>
        ) : (
          <Col>
            <Row style={{ padding: "2vh" }}>
              <Typography.Text>
                Make Job Offer to{" "}
                <Typography.Text strong>
                  {firstName} {lastName}
                </Typography.Text>
              </Typography.Text>
            </Row>
            <Row style={{ padding: "2vh" }}>
              <Typography.Paragraph>
                Click confirm to make offer
              </Typography.Paragraph>
            </Row>
            <Row justify="end">
              <StyledButton
                color="#15EA5F"
                textColor="#222222"
                onClick={giveOffer}
                data-testid="submit-confirm"
              >
                Confirm
              </StyledButton>
            </Row>
          </Col>
        )}
      </Modal>
    </Col>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    getOfferProgress: (jobId) => dispatch(getOfferProgress(jobId)),
  };
};

export default connect(null, mapDispatchToProps)(UserCard);
